import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MapWaypoint, ScoutPath } from '../../core/models';
import { WaypointsPlotterComponent } from '../waypoints-plotter/waypoints-plotter.component';
import { PathWaypointService } from '../../core/services/path-waypoint.service';
import { PathService, PointService } from '../../core/services';
import { WaypointListComponent } from '../waypoint-list/waypoint-list.component';
import { AppTab } from '../../core/app-tab';
import { asyncScheduler, firstValueFrom, Subject } from 'rxjs';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import { RoleMgr } from '../../core';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PathKmlViewerModal } from '../path-kml-viewer/path-kml-viewer-modal/path-kml-viewer-modal.component';


@Component({
  selector: 'app-path-view',
  templateUrl: './path-view.component.html',
  styleUrls: ['./path-view.component.scss']
})
export class PathViewComponent {

  title$: Subject<string>;

  @Input() set tabConfig( tabConfig : AppTab ) {
    tabConfig.setSelected = this.onTabSelected
    this.title$ = tabConfig.viewInfo.title
    if ( this.pathId ) {
      this.title$.next(this.buildTabTitle())
    }
  }

  // Allow home tab to set pathId and buildingId with just "itemId"
  @Input('contextJson') set contextJsonSetter(strJson: string) {
    console.log(`contextJson(${strJson})`)
    try {
      const context = JSON.parse(strJson);
      if ( !context.pathId ) {
        this.pathWaypointService.publishError('"pathId" is required',this)
      } else if ( !context.buildingId ) {
        this.pathWaypointService.publishError('"buildingId" is required',this)
      } else {
        this.pathId = context.pathId;
        this.buildingId = context.buildingId;
        this.defaultPointId = context.defaultPointId;
      }
    } catch (error) {
      console.error(error)
      this.pathWaypointService.publishError(error, this);
    }
    this.title$.next(this.buildTabTitle())
  }

  @Input() public pathId : string
  @Input() public buildingId : string
  @Input() public defaultPointId: string;

  @Output('pointSelected') pointSelectedEmitter = new EventEmitter<MapWaypoint>()
  @ViewChild('waypointList') waypointList : WaypointListComponent
  @ViewChild('waypointsPlotter') waypointsPlotter : WaypointsPlotterComponent

  bTabSelected = false
  selectedMapWaypoint: MapWaypoint

  bMissingSegmentCandidate = false;
  bWaypointsModified = false;
  bResetting = false;
  resolvedScoutPath: ScoutPath;


  constructor(
      public roleMgr: RoleMgr,
      protected pointService : PointService,
      protected pathService: PathService,
      protected pathWaypointService: PathWaypointService,
      protected modalService: BsModalService,
    ) {
  }

  buildTabTitle = () => `Path ${this.pathId||'?'}`;

  onClickPin( mwp : MapWaypoint ) {
    console.log('onClickPin() ' + mwp?.id)
    this.waypointsPlotter.setSelectedPointById(mwp.id)
  }


  onMapWaypointsChanged( mapWayPoints : MapWaypoint[] ) {

    // If path has a few waypoints without a fromPointId it could be issue with one source import
    // so enable a button allowing admin to reassign fromPointId directly from scout path data
    const noFromPtCnt = mapWayPoints?.filter(pt=>!pt.pathWaypoint.fromPointId).length;
    this.bMissingSegmentCandidate = noFromPtCnt > 1;

    if ( this.defaultPointId ) {
      const ptId = this.defaultPointId;
      this.defaultPointId = null;
      this.selectedMapWaypoint = mapWayPoints.find(pt=>pt?.pointId==ptId)
      this.waypointList.selectedId = this.selectedMapWaypoint?.id
      if ( this.selectedMapWaypoint?.id ) {
        asyncScheduler.schedule( () => {
          this.waypointsPlotter.setSelectedPointById(this.selectedMapWaypoint.id)
        })
      } else {
        this.pathWaypointService.appState.notifyWarning(
          `Point '${ptId}' not in waypoint data.`,
          this, 5 );
      }
    }
    else if ( !this.waypointList.selectedId && mapWayPoints?.length ) {
      this.selectedMapWaypoint = mapWayPoints[this.waypointsPlotter.selectedIndex]
      this.waypointList.selectedId = this.selectedMapWaypoint?.id
    }
    this.waypointsPlotter.plotWaypointsWhenReady(this.pathId,mapWayPoints)
  }


  onMapWaypointSelected( mwp : MapWaypoint ) {
    console.log('onMapWaypointSelected() ' + mwp?.id)
    if ( this.waypointList ) {
      this.waypointList.selectedId = mwp?.id
    }
    this.selectedMapWaypoint = mwp
    this.pointSelectedEmitter.emit(mwp)
  }

  onResolvedScoutPath(event:{scoutTask: ScoutTaskDoc,scoutPath: ScoutPath}) {
    this.resolvedScoutPath = event?.scoutPath;
  }

  onAssignSegmentsFromScoutPath() {
    const mapWaypoints = this.waypointList.waypointTableRows.map(row=>row.mapWaypoint);
    //console.log('onAssignSegmentsFromScoutPath()',this.resolvedScoutPath);
    for( const mapWaypoint of mapWaypoints ) {
      const scoutPt = this.resolvedScoutPath?.scoutPoints.find(pt=>pt.name?.trim()===mapWaypoint.name?.trim());
      if ( scoutPt ) {
        const scoutParentPt = this.resolvedScoutPath?.scoutPoints.find(pt=>pt.id===scoutPt.parentId);
        if ( scoutParentPt ) {
          const wpParent = mapWaypoints.find(pt=>pt.name?.trim()===scoutParentPt.name?.trim());
          if ( wpParent ) {
          mapWaypoint.pathWaypoint.fromPointId = wpParent.pointId;
          mapWaypoint.parentId = wpParent.id;
            //console.log(`setting ${mapWaypoint.name} ${mapWaypoint.exPointId}.fromPointId to `,  mapWaypoint.pathWaypoint.fromPointId, ` scoutParentPt`, scoutParentPt);
          } else {
            console.warn('no wpParentPt for ', mapWaypoint.name, {scoutParentPt,mapWaypoints});
          }
        } else {
          console.warn('no scoutParentPt for ', mapWaypoint.name);
        }
      } else {
        console.warn('no scoutPt for ', mapWaypoint.name);
      }
    }
    console.log('onAssignSegmentsFromScoutPath()',{mapWaypoints});
    this.bWaypointsModified = true;
    this.waypointsPlotter.plotWaypointsWhenReady(this.pathId,mapWaypoints)
  }

  async onSaveWaypoints() {
    //this.bWaypointsModified = false;
    let bConfirmed = false;
    let initialState = {
      onYes: () => bConfirmed = true,
      title: 'Save Path Changes?',
      question: `Overwrite Waypoints from One Source import (apply scout path segments as shown in map)?`,
      focusOnNo: true,
      yesStyle: "btn btn-danger",
    };
    const modalRef = this.modalService.show(ConfirmModalComponent, { initialState });
    await firstValueFrom(modalRef.onHidden);
    console.log('onSaveWaypoints()',{bConfirmed});
    if ( !bConfirmed ) {
      return;
    }
    const wpList = this.waypointList.waypointTableRows.map(row=>({_id: row.mapWaypoint.pathWaypoint._id,fromPointId: row.mapWaypoint.pathWaypoint.fromPointId}));
    console.log('onSaveWaypoints()',{wpList});
    await this.pathWaypointService.partialUpdate(wpList);
    this.bWaypointsModified = false;
  }

  onReset(delayMs=0) {
    this.bWaypointsModified = false;
    this.bResetting = true;
    asyncScheduler.schedule( () => {
      this.bResetting = false;
    }, delayMs);
  }

  onTabSelected = ( bSelected : boolean ) => {
    this.bTabSelected = bSelected

    // Handle when window resized while not on this tab
    if ( bSelected && this.waypointsPlotter?.map ) {
      asyncScheduler.schedule( () => this.waypointsPlotter?.map?.invalidateSize() )
    }
  }

  async showKmlViewer() {
    const buildingId = this.waypointList?.waypointTableRows?.[0].buildingId;
    const paths = await this.pathWaypointService.findBuilding3dPaths(buildingId);
    console.log('showKmlViewer()',{buildingId,paths});
    PathKmlViewerModal.show(this.modalService, {
      selectedPathIds: [this.pathId],
      buildingId: this.waypointList?.waypointTableRows?.[0].buildingId,
      paths
    });
  }
}
